// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingInfoRow_root__1jq8H","title":"BookingInfoRow_title__7tPXh","body":"BookingInfoRow_body__3Q1wg"};